// AppContext.js
import React, { createContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [sliderValue, setSliderValue] = useState(0);
  const [valuesArray, setValuesArray] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [audienceResponseHashTable, setAudienceResponseHashTable] = useState({});

  return (
    <AppContext.Provider value={{
      sliderValue,
      setSliderValue,
      valuesArray,
      setValuesArray,
      isRecording,
      setIsRecording,
      audienceResponseHashTable,
      setAudienceResponseHashTable
    }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
